
export default {
  name: 'PopUpSelectTransport',

  props: {
    categorySlug: {
      type: String,
      default: '',
    },
  },

  computed: {
    isOpen: function () {
      return this.$store.state['pop-up-select-transport']?.isOpen || false;
    },
  },

  components: {
    SelectionCars: () => import('~/cms/blocks/components/BannerBlock/_SelectionCars'),
  },

  methods: {
    closeForm: function () {
      this.$store.commit('pop-up-select-transport/setOpen', false);
    },
  },
};
